require('intersection-observer');
import Vue from 'vue';
import VueAnalytics from 'vue-ua';
import router from './router';
import store from './store';
import App from './App';
import EventBusPlugin from '@/plugins/EventBusPlugin';
import MobileDetectPlugin from '@/plugins/MobileDetectPlugin';
import { sync } from 'vuex-router-sync';
import { config } from './config';

import BootstrapVue from 'bootstrap-vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
//import 'babel-polyfill';
import VueScrollTo from 'vue-scrollto';
import VueScrollMonitor from 'vue-scrollmonitor';

import '@/vendors/neo-video-controls.min';

Vue.config.productionTip = false;

// 3rd party styles
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'animate.css/animate.min.css';

// global app styles
require('./styles/index.scss');

Vue.use(EventBusPlugin);
Vue.use(MobileDetectPlugin);
Vue.use(BootstrapVue);
// eslint-disable-next-line
Vue.use(NeoVideoControls.default);
Vue.use(VueScrollMonitor);

Vue.use(VueScrollTo, {
    container: 'body',
    duration: 600,
    easing: 'ease-in-out',
    offset: 0,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.use(VueAnalytics, {
    appName: config.appName,
    appVersion: config.appVersion,
    trackingId: config.gaID,
    vueRouter: router,
    trackPage: true,
    debug: true
});

sync(store, router);

// eslint-disable-next-line
const app = new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        AOS.init();
    }
}).$mount('#app');
